<div
    class="about-visualization-component"
    [class.gap-24]="!pdf"
    [class.gap-8]="pdf"
>
    @if (visualization()?.props.description) {
        <div class="about-visualization-component__card">
            <h2 [class]="pdf ? 'text-10-semi-bold' : 'text-12-semi-bold'">
                Descrição
            </h2>
            <div
                class="about-visualization-component__card-info"
                [class.pdf]="pdf"
            >
                <p
                    [class.text-10-regular]="pdf"
                    [class.text-12-regular]="!pdf"
                    [innerHTML]="visualization()?.props.description"
                ></p>
            </div>
        </div>
    }
    @if (!pdf) {
        <div class="about-visualization-component__card">
            <h2 [class]="pdf ? 'text-10-semi-bold' : 'text-12-semi-bold'">
                Fórmulas
            </h2>
            <div
                class="about-visualization-component__card-info gap-8 overflow-x"
                fxLayout="column"
            >
                @for (serie of series; track $index) {
                    <div
                        fxLayout="row"
                        fxLayoutAlign="none center"
                        class="gap-8 about-visualization-component__card__calc"
                    >
                        <p
                            class="color-text-primary"
                            [class]="
                                pdf ? 'text-8-semi-bold' : 'text-12-semi-bold'
                            "
                            style="
                                max-width: 300px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            "
                        >
                            {{ serie.props.name }}
                        </p>
                        <span class="color-text-primary text-12-semi-bold"
                            >=</span
                        >
                        <span
                            class="general-formula katex color-text-primary"
                            [class]="pdf ? 'text-8-regular' : 'text-12-regular'"
                            [id]="'Formula-' + $index"
                        ></span>
                    </div>
                }
            </div>
        </div>
    }
</div>
